import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { AboutThisPage, PageHeader } from '../../ui/primitives';
import AtoReportsTab from './AtoReportsTab';
import TaxStatementsTab from './TaxStatementsTab';
import WithholdingTab from './WithholdingTab';

export default function TaxPage() {
  const [tab, setTab] = useState(0);
  return (
    <>
      <PageHeader
        title="Tax & ATO"
        subtitle="Year-end AMMA statements for investors, and the reports the trustee lodges with the ATO."
      />
      <AboutThisPage>
        <p>
          Tax statements are generated from the ledger (what each holder received) and the final tax
          components from the fund accountant. The AIIR to the ATO is produced from the same data,
          so the two always agree. TFN reports, FATCA and CRS use the holder data captured at
          onboarding.
        </p>
      </AboutThisPage>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={(_event, next) => setTab(next)} variant="scrollable">
          <Tab label="Investor tax statements" />
          <Tab label="ATO reporting" />
          <Tab label="Withholding" />
        </Tabs>
      </Box>
      {tab === 0 && <TaxStatementsTab />}
      {tab === 1 && <AtoReportsTab />}
      {tab === 2 && <WithholdingTab />}
    </>
  );
}
